import { Component, OnDestroy, OnInit } from '@angular/core';
import { DatepickerOptions } from 'ng2-datepicker';
import locale from 'date-fns/locale/pt';
import { ComponentBase } from 'src/app/main/dynamic/component-base';

import * as jQuery from 'jquery';
import { ProcessService } from 'src/app/service/process.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-input-datepicker',
  templateUrl: './input-datepicker.component.html',
  styleUrls: ['./input-datepicker.component.scss']
})
export class InputDatepickerComponent extends ComponentBase implements OnInit, OnDestroy {


  date: Date;
  options: DatepickerOptions = {
    minYear: 1900,
    maxYear: 2100,
    format: 'dd/MM/yyyy',
    formatTitle: 'MMMM yyyy',
    formatDays: 'dd',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    locale: locale,
    //minDate: new Date(Date.now()), // Minimal selectable date
    // maxDate: new Date(Date.now()),  // Maximal selectable date
    // barTitleIfEmpty: '',
    placeholder: '', // HTML input placeholder attribute (default: '')
    // inputClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
  };
  loadingSubscription: Subscription;

  constructor(private processService: ProcessService) {
    super();

    this.loadingSubscription = this.processService.getLoadingNotification().subscribe(isLoaded => {
      if (isLoaded) {
        this.loadDate()
      }
    });
  }

  ngOnInit() {
    this.loadDate();
  }

  ngOnDestroy() {
    this.loadingSubscription.unsubscribe()
  }

  private loadDate() {
    if (this.attribute.value) {
      this.date = new Date(this.attribute.value);
    } else {
      this.date = null;
    }
  }

  changedDate(event) {
    this.date = new Date(event)
    this.attribute.value = this.date.toISOString()
    this.emit({ name: "autosave", data: "silently" })
  }


  getValue(): Date {
    if(!this.attribute.value) {
      return null
    } else {
      return new Date(this.attribute.value)
    }
  }
}
